$.Fotorama.cache = {};